import { SettingsSection } from './SettingsSection';
import { SettingsTranslationKeys } from '../../../api/models/TranslationKeys';
import { Log } from '@lightningjs/sdk';
import { ScrollList } from '../../../components/shared/ScrollList';
import { CustomerSettingsKeys } from '../../../api/models/CustomerSettingsKeys';
import { GlobalSettingsKeys } from '../../../api/models/GlobalSettingsKeys';
import { Backend } from '../../../api/Backend';
import { CheckBox } from '../../detail/recording/CheckBox';

export class AutoplaySection extends SettingsSection {
  constructor(backend: Backend) {
    super(backend, backend.translations.forKey(SettingsTranslationKeys.settings_autoplay_title));
  }

  override addControls(list: ScrollList) {
    if (!this.backend.globalSettings.boolValue(GlobalSettingsKeys.autoplayWatchingEnabledVod)) {
      // if not defined, also don't show
      return;
    }
    super.addControls(list);
    const autoplayElement = this.addAutoplayEnabledElement(list);
    this.addAutoplayEnabledData(autoplayElement);
  }

  addAutoplayEnabledElement(list: ScrollList) {
    return list.items.childList.a({
      type: CheckBox,
      y: 8,
    });
  }

  private addAutoplayEnabledData(element: CheckBox) {
    this.backend.cachedCustomerSettings
      .getSetting(this.backend, CustomerSettingsKeys.autoplay_enabled)
      .then(res => {
        if (res?.value) {
          res.value = res.value.toLowerCase();
          if (res.value === 'true') {
            return true;
          }
          if (res.value === 'false') {
            return false;
          }
        }
        // default is customer setting autoplay enabled
        const customerDefault = this.backend.globalSettings.boolValue(GlobalSettingsKeys.autoplayCustomerDefault);
        if (customerDefault === undefined) {
          return true; // fallback when global setting doesn't exist
        } else {
          return customerDefault;
        }
      })
      .catch(err => {
        Log.error(err);
        return true;
      })
      .then((currentSetting: boolean) => {
        element.label = this.backend.translations.forKey(SettingsTranslationKeys.settings_autoplay);
        element.value = currentSetting;
        element.signals = {};
        element.signals.valueChanged = value => {
          this.backend.cachedCustomerSettings.setSetting(
            this.backend,
            CustomerSettingsKeys.autoplay_enabled,
            value.toString()
          );
        };
      });
  }
}
